import { parseQuery } from '@pressreader/routing';

import DefaultProvider, { AuthContext, AuthorizationRequestUrlArgs, RequestAuthorizationArgs } from './default.provider';

interface ProcessAuthorizationContext extends AuthContext {
    barcode?: string;
    pin?: string;
    provider?: string;
}

interface ProcessAuthorizationArgs {
    context?: ProcessAuthorizationContext;
}

class LibraryBaseProvider extends DefaultProvider {
    override requestAuthorization({ provider, authtype, key, url, context }: RequestAuthorizationArgs): Promise<unknown> {
        // standalone window mode, out of pressreader site, used by native apps
        if (context.isWindowMode) {
            window.location.href = url;
            return Promise.resolve();
        }

        return super.requestAuthorization({ provider, authtype, key, url, context });
    }

    /**
     * Process authorization step for native apps (standalone window mode).
     * Posts barcode/pin back to the server via a redirect.
     */
    processAuthorization({ context = {} }: ProcessAuthorizationArgs): void {
        const codeJson = JSON.stringify({
            barcode: context.barcode,
            pin: context.pin,
        });
        const code = window.btoa(codeJson);
        const query = window.location.search.slice(1);
        const state = parseQuery(query).state || '';
        const baseUrl = window.basePath;
        const path = 'externalauth/processauthorization/';

        const url = `${baseUrl}${path}?state=${state}&code=${code}&libraryId=${context.library}&provider=${context.provider}`;
        window.location.href = url;
    }

    /**
     * Adds library id to the authorization request url.
     */
    override getAuthorizationRequestUrl({ provider, key, token, authtype, context = {} }: AuthorizationRequestUrlArgs): string {
        const baseUrl = super.getAuthorizationRequestUrl({ provider, key, token, authtype, context });
        return `${baseUrl}&libraryId=${context.library}`;
    }
}

export { ProcessAuthorizationArgs, ProcessAuthorizationContext };
export default LibraryBaseProvider;
